<template>
  <div
    class="text-center"
  >
    <v-dialog
      v-model="isLoading"
      hide-overlay
      persistent
      max-width="500"
    >
      <v-card
        class="pt-1"
        color="primary"
      >
        <v-card-text
          class="font-weight-bold text-center"
        >
          <h3>{{ title }}</h3>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ["title", "loading"],
  computed: {
    isLoading() {
      return this.loading;
    },
  },
};
</script>